import { InjectionToken } from '@angular/core'

export type PresenterMode = 'auction' | 'template'

export interface PresenterContext {
  mode: PresenterMode
  templateUuid?: string
}

export const PRESENTER_CONTEXT = new InjectionToken<PresenterContext>('PRESENTER_CONTEXT', {
  providedIn: 'root',
  factory: (): PresenterContext => ({ mode: 'auction' }),
})
